import { openTimesheetAdjustmentModal } from '../../../State/timesheetAdjustmentModal'

export default (timesheetAdjustment) => (dispatch) => {

  dispatch(openTimesheetAdjustmentModal({ timesheetAdjustment }))

}
